import React from 'react';
import { ShieldCheckIcon, DropletsIcon, CheckIcon, StarIcon } from 'lucide-react';
export function OptinPage() {
  return <main className="min-h-screen w-full bg-[#f8f7f4] text-[#1e293b] font-sans selection:bg-[#b91c1c] selection:text-white flex flex-col items-center justify-center p-4 sm:p-8 relative overflow-hidden" data-id="element-1">
      {/* Background Texture/Noise Overlay */}
      <div className="absolute inset-0 opacity-[0.02] pointer-events-none bg-[url('https://www.transparenttextures.com/patterns/stardust.png')]" data-id="element-2"></div>

      {/* Subtle Gradient Glow — soft red/blue tint */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-96 bg-[#dbeafe] opacity-40 blur-[120px] rounded-full pointer-events-none" data-id="element-3"></div>
      <div className="absolute bottom-0 right-1/4 w-72 h-72 bg-[#fecaca] opacity-20 blur-[100px] rounded-full pointer-events-none" data-id="element-4"></div>

      <div className="relative z-10 w-full max-w-xl mx-auto space-y-8" data-id="element-5">
        {/* Header Section */}
        <div className="text-center space-y-6" data-id="element-6">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded border border-[#002868] bg-[#002868] text-white text-xs font-bold tracking-widest uppercase shadow-md" data-id="element-7">
            <StarIcon className="w-3 h-3 fill-current" data-id="element-8" />
            Free Survival Guide
            <StarIcon className="w-3 h-3 fill-current" data-id="element-9" />
          </div>

          <h1 className="text-4xl sm:text-5xl md:text-6xl font-extrabold tracking-tight leading-tight text-[#0f172a]" data-id="element-10">
            Never Worry About{' '}
            <span className="text-[#b91c1c]" data-id="element-11">Clean Water</span> Again
          </h1>

          <p className="text-lg sm:text-xl text-[#475569] max-w-md mx-auto leading-relaxed" data-id="element-12">
            Discover the{' '}
            <span className="font-semibold text-[#0f172a]" data-id="element-13">
              DIY Biosand System
            </span>{' '}
            that turns dirty river, rain, or well water into safe drinking
            water.
          </p>
        </div>

        {/* Content Card */}
        <div className="bg-white border border-[#e2e8f0] rounded-xl shadow-xl overflow-hidden" data-id="element-14">
          <div className="p-6 sm:p-8 space-y-8" data-id="element-15">
            {/* Benefits List */}
            <div className="space-y-4" data-id="element-16">
              <h3 className="text-sm font-bold uppercase tracking-wider text-[#64748b] border-b border-[#e2e8f0] pb-2 mb-4" data-id="element-17">
                What You'll Discover Inside:
              </h3>
              <ul className="space-y-3" data-id="element-18">
                {['Works with river, rain, or well water', 'No electricity or chemicals needed', 'Built from common materials', 'Lasts for decades with zero maintenance'].map((benefit, index) => <li key={index} className="flex items-start gap-3" data-id="element-19">
                    <div className="mt-1 flex-shrink-0 w-5 h-5 rounded-full bg-[#fef2f2] flex items-center justify-center border border-[#fecaca]" data-id="element-20">
                      <CheckIcon className="w-3 h-3 text-[#b91c1c]" data-id="element-21" />
                    </div>
                    <span className="text-[#334155]" data-id="element-22">{benefit}</span>
                  </li>)}
              </ul>
            </div>

            {/* AWeber Form */}
            <div className="bg-[#f1f5f9] rounded-lg p-6 border border-[#e2e8f0]" data-id="element-23">
              <div className="flex items-center gap-2 mb-4 text-[#1b2a4a]" data-id="element-24">
                <DropletsIcon className="w-5 h-5" data-id="element-25" />
                <span className="font-bold text-sm tracking-wide uppercase" data-id="element-26">
                  Get Instant Access
                </span>
              </div>

              <form method="post" className="space-y-4" acceptCharset="UTF-8" action="https://www.aweber.com/scripts/addlead.pl" data-id="element-27">
                {/* Hidden Fields */}
                <div style={{
                display: 'none'
              }} data-id="element-28">
                  <input type="hidden" name="meta_web_form_id" value="81158804" data-id="element-29" />
                  <input type="hidden" name="meta_split_id" value="" data-id="element-30" />
                  <input type="hidden" name="listname" value="awlist6453181" data-id="element-31" />
                  <input type="hidden" name="redirect" value="https://www.google.com" id="redirect_37e5a7462623c91039039bd4a2683c77" data-id="element-32" />
                  <input type="hidden" name="meta_adtracking" value="Simple_Optin_1" data-id="element-33" />
                  <input type="hidden" name="meta_message" value="1" data-id="element-34" />
                  <input type="hidden" name="meta_required" value="email" data-id="element-35" />
                  <input type="hidden" name="meta_tooltip" value="" data-id="element-36" />
                </div>

                {/* Email Input */}
                <div data-id="element-37">
                  <label htmlFor="awf_field-118536433" className="sr-only" data-id="element-38">
                    Email Address
                  </label>
                  <input className="w-full bg-white text-[#0f172a] placeholder-[#94a3b8] border-2 border-[#cbd5e1] rounded px-4 py-3.5 text-lg font-medium focus:outline-none focus:ring-2 focus:ring-[#b91c1c] focus:border-transparent transition-all shadow-sm" id="awf_field-118536433" type="email" name="email" placeholder="Enter your email address..." tabIndex={500} required data-id="element-39" />
                </div>

                {/* Submit Button */}
                <div className="relative group" data-id="element-40">
                  <div className="absolute -inset-0.5 bg-[#b91c1c] rounded blur opacity-20 group-hover:opacity-50 transition duration-200" data-id="element-41"></div>
                  <input name="submit" className="relative w-full bg-[#b91c1c] hover:bg-[#991b1b] text-white font-bold uppercase tracking-wider py-4 px-6 rounded cursor-pointer transition-colors shadow-lg transform active:scale-[0.99]" type="submit" value="Get Your Free Guide" tabIndex={501} data-id="element-42" />
                </div>

                {/* Tracking Pixel */}
                <div style={{
                display: 'none'
              }} data-id="element-43">
                  <img src="https://forms.aweber.com/form/displays.htm?id=HIyMrBwcDCw=" alt="" data-id="element-44" />
                </div>
              </form>

              {/* Privacy Note */}
              <div className="mt-4 flex items-center justify-center gap-2 text-xs text-[#94a3b8]" data-id="element-45">
                <ShieldCheckIcon className="w-3 h-3" data-id="element-46" />
                <p data-id="element-47">Your email is safe. No spam, ever. Unsubscribe anytime.</p>
              </div>
            </div>
          </div>

          {/* Card Footer Decoration — Red, White, Blue stripe */}
          <div className="h-2 w-full flex" data-id="element-48">
            <div className="flex-1 bg-[#b91c1c]" data-id="element-49"></div>
            <div className="flex-1 bg-[#f8f7f4]" data-id="element-50"></div>
            <div className="flex-1 bg-[#1b2a4a]" data-id="element-51"></div>
          </div>
        </div>

        {/* Footer */}
        <footer className="text-center text-[#94a3b8] text-xs" data-id="element-52">
          <p data-id="element-53">
            &copy; {new Date().getFullYear()} Survival Systems. All rights
            reserved.
          </p>
        </footer>
      </div>
    </main>;
}